/* ========== STOCK CHART (OHLC / High-Low-Close) ========== */

import { COLORS, drawAxes, drawGridlines, drawLegend } from './utils';

export function drawStockChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allVals = seriesArr.flatMap(function (s) { return s.data; });
  var maxValue = Math.max.apply(null, allVals.concat([0])) || 100;
  var minValue = Math.min.apply(null, allVals.concat([0]));
  var range = maxValue - minValue || 100;
  var numPoints = Math.max.apply(null, seriesArr.map(function (s) { return s.data.length; }));
  var cats = chartObj.categories || [];

  drawGridlines(ctx, x, y, width, height, minValue, range);

  var colW = width / Math.max(numPoints, 1);

  if (seriesArr.length >= 3) {
    var hasOpen = seriesArr.length >= 4;
    var highS = hasOpen ? seriesArr[1] : seriesArr[0];
    var lowS = hasOpen ? seriesArr[2] : seriesArr[1];
    var closeS = hasOpen ? seriesArr[3] : seriesArr[2];
    var openS = hasOpen ? seriesArr[0] : null;

    for (var i = 0; i < numPoints; i++) {
      var cx = x + i * colW + colW / 2;
      var highVal = highS && highS.data[i] !== undefined ? highS.data[i] : 0;
      var lowVal = lowS && lowS.data[i] !== undefined ? lowS.data[i] : 0;
      var closeVal = closeS && closeS.data[i] !== undefined ? closeS.data[i] : 0;
      var openVal = openS && openS.data[i] !== undefined ? openS.data[i] : closeVal;

      var highY = y + height - ((highVal - minValue) / range) * height;
      var lowY = y + height - ((lowVal - minValue) / range) * height;
      var openY = y + height - ((openVal - minValue) / range) * height;
      var closeY = y + height - ((closeVal - minValue) / range) * height;

      var bullish = closeVal >= openVal;
      var barColor = bullish ? '#70AD47' : '#ED7D31';

      ctx.strokeStyle = '#555';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(cx, highY);
      ctx.lineTo(cx, lowY);
      ctx.stroke();

      var bodyTop = Math.min(openY, closeY);
      var bodyHeight = Math.max(Math.abs(openY - closeY), 1);
      var bodyW = colW * 0.5;
      ctx.fillStyle = barColor;
      ctx.fillRect(cx - bodyW / 2, bodyTop, bodyW, bodyHeight);
      ctx.strokeStyle = barColor;
      ctx.lineWidth = 1;
      ctx.strokeRect(cx - bodyW / 2, bodyTop, bodyW, bodyHeight);
    }
  } else {
    seriesArr.forEach(function (series, sIdx) {
      var color = COLORS[sIdx % COLORS.length];
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      series.data.forEach(function (val, i) {
        var px = x + i * colW + colW / 2;
        var py = y + height - ((val - minValue) / range) * height;
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      });
      ctx.stroke();
    });
  }

  for (var ci = 0; ci < numPoints; ci++) {
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[ci] || ('' + (ci + 1)), x + ci * colW + colW / 2, y + height + 6);
  }

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}
